module.exports = __webpack_public_path__ + "img/boton_2.d9ac929e.png";